"use client";
'use strict';

var React = require('react');
var SiteSettingsProvider = require('../providers/SiteSettingsProvider.js');

function useSiteSettings() {
    const selectedLocation = React.useContext(SiteSettingsProvider.SiteSettingsContext);
    return selectedLocation;
}

exports.useSiteSettings = useSiteSettings;
//# sourceMappingURL=useSiteSettings.js.map
